import { useContext, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { PostAPI } from "../../../ApiServices/ApiServices";
import AppContext from "../../../Context/AppContext";
import Assets from "../../../Assets/Assets";
import { toast } from "react-toastify";

const Login = () => {
  const navigate = useNavigate();
  const { user, setUser } = useContext(AppContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [eyeOpen, setEyeOpen] = useState(false);

  // Form validation
  const validate = () => {
    let valid = true;
    let newErrors = {};
    if (!email) {
      newErrors.email = "Email is required";
      valid = false;
    }
    if (!password) {
      newErrors.password = "Password is required";
      valid = false;
    }
    setErrors(newErrors);
    return valid;
  };

  const signIn = async () => {
    // Check network status before API call
    if (!navigator.onLine) {
      toast.error("Login failed. Please check your internet connection", { autoClose: 1500 });
      return;
    }

    if (!validate()) return; // Exit if validation fails
    try {
      const url = "/login";
      const data = {
        email,
        password,
        role: 3, // Assuming this is the correct role for the user
      };

      PostAPI({ url, data }, async (res) => {
        if (res?.code === 200 && res?.status === 1) {
          // Save user data and token
          localStorage.setItem("loginInfo", JSON.stringify(res?.data));
          const LoginInfo = localStorage.getItem("loginInfo");
          setUser({ type: "login", loginInfo: JSON.parse(LoginInfo) });
          localStorage.setItem("loggedIn", "true");
          localStorage.setItem("token", JSON.stringify(res?.token));
          localStorage.setItem("userId", res?.data?.id);

          toast.success("Login Successful", { autoClose: 1500 });
          navigate("/"); // Navigate to the dashboard or home page
        } else {
          toast.error(res?.message || "Login failed. Please try again.", { autoClose: 1500 });
        }
      });
    } catch (error) {
      console.error("Error during login:", error);
      // Updated error message for network issues
      toast.error("Login failed. Please check your internet connection", { autoClose: 1500 });
    }
  };

  return (
    <div className="login-form container">
      <div className="right-content">
        <p className="wel-content">
          <span className="color-txt">Hello! there,</span> Welcome Back
        </p>
        <h4 className="form-head">Login</h4>
      </div>
      <div className="form-box">
        <Form>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter Email ID here"
              className="login-input"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors.email && <div className="error-text">{errors.email}</div>}
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <div className="password-input-container">
              <div className="eye-setup">
                <Form.Control
                  type={eyeOpen ? "text" : "password"}
                  placeholder="Enter Password here"
                  className="login-input"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <img
                  src={eyeOpen ? Assets.eyeOpen : Assets.eyeClose}
                  alt="eye-image"
                  className="eye-img"
                  onClick={() => setEyeOpen(!eyeOpen)}
                />
              </div>
              {errors.password && <div className="error-text">{errors.password}</div>}
            </div>
          </Form.Group>
          <small className="forgot-text">
            <Link to={"/forgotpassword"}>Forgot Password?</Link>
          </small>
          <Button variant="primary" onClick={signIn}>
            Sign in
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default Login;